import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {actionTypes} from "./actions" 


const initialAuthState = {
    messageData: undefined
};

// const persistReducer = persistReducer(persistConfig, rootReducer);  // 包装rootReducer
export const reducer = persistReducer(
  { storage, key: "uerInfo", whitelist: ["user", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {

      case actionTypes.LoadMessageDetailSuccess: {
        const  {data}  = action.payload;
        console.log(data);
        return { ...state, data };
      }

      case actionTypes.LoadMessageDetailFailed: {
        console.log('LoadMessageDetailFailed')
        const  {msg}  = action.payload;
        return { ...state, msg: msg };
      }

      case actionTypes.SetSearchString: {
        console.log('SetSearchString')
        const  {data}  = action.payload;
        return { ...state, searchStr: data };
      }

      default:
        return state;
    }
  }
);


